export const referralOverrides = [
    {
        "id": "7",
        "description": "Έλεγχος Μέσου Παραπεμπτικoύ",
        "parentId": ""
    },
    {
        "id": "103",
        "description": "Έλεγχος Διαγνώσεων εξέτασης - βήμα 3",
        "parentId": "1"
    },
    {
        "id": "102",
        "description": "Έλεγχος Διαγνώσεων εξέτασης - βήμα 2",
        "parentId": "1"
    },
    {
        "id": "1",
        "description": "Έλεγχος Διαγνώσεων εξέτασης",
        "parentId": ""
    },
    {
        "id": "101",
        "description": "Έλεγχος Διαγνώσεων εξέτασης - βήμα 1",
        "parentId": "1"
    },
    {
        "id": "104",
        "description": "Έλεγχος Διαγνώσεων εξέτασης - βήμα 4",
        "parentId": "1"
    },
    {
        "id": "2",
        "description": "Ακριβή Εξέταση",
        "parentId": ""
    },
    {
        "id": "5",
        "description": "Επίσκεψη ασθενή στην ίδια ειδικότητα",
        "parentId": ""
    },
    {
        "id": "6",
        "description": "Επίσκεψη ασθενή σε διαφορετικές ειδικότητες",
        "parentId": ""
    },
    {
        "id": "8",
        "description": "Επανάληψη εξέτασης ανά ΑΜΚΑ",
        "parentId": ""
    },
    {
        "id": "10",
        "description": "Επανασυνταγογράφηση δραστικής ουσίας",
        "parentId": "",
        "reasons": [
            { value: "519", label: "Τιτλοποίηση δόσης" },
            { value: "521", label: "Τροποποίηση συσκευασίας λόγω έλλειψης" },
            { value: "586", label: "Παράταση συνταγής" },
        ]
    },
    {
        "id": "801",
        "description": "Προληπτική Ιατρική - Δράση Πρόληψης του Καρκίνου του Παχέος Εντέρου",
        "parentId": ""
    },
    {
        "id": "4",
        "description": "Έλεγχος πακέτων εξετάσεων σε παραπεμπτικό",
        "parentId": ""
    },
    {
        "id": "501",
        "description": "Διαγνωστικό Πρωτόκολλο Δισλιπιδαιμίας",
        "parentId": "",
        "reasons": [
            { value: "138", label: "Ιανουάριος" },
            { value: "139", label: "Φεβρουάριος" },
            { value: "140", label: "Μάρτιος" },
            { value: "141", label: "Απρίλιος" },
            { value: "142", label: "Μάϊος" },
            { value: "143", label: "Ιούνιος" },
            { value: "144", label: "Ιουλιος" },
            { value: "146", label: "Αύγουστος" },
            { value: "147", label: "Σεπτέμβριος" },
            { value: "148", label: "Οκτώβριος" },
            { value: "149", label: "Νοέμβριος" },
            { value: "150", label: "Δεκέμβριος" },
        ]
    },
    {
        "id": "510",
        "description": "Διαγνωστικό Πρωτόκολλο Οστεοπόρωσης",
        "parentId": ""
    },
    {
        "id": "511",
        "description": "Διαγνωστικό Πρωτόκολλο Οστεοπόρωσης",
        "parentId": "510",
        "reasons": [
            { value: "138", label: "Ιανουάριος" },
            { value: "139", label: "Φεβρουάριος" },
            { value: "140", label: "Μάρτιος" },
            { value: "141", label: "Απρίλιος" },
            { value: "142", label: "Μάϊος" },
            { value: "143", label: "Ιούνιος" },
            { value: "144", label: "Ιουλιος" },
            { value: "146", label: "Αύγουστος" },
            { value: "147", label: "Σεπτέμβριος" },
            { value: "148", label: "Οκτώβριος" },
            { value: "149", label: "Νοέμβριος" },
            { value: "150", label: "Δεκέμβριος" },
        ]
    },
    {
        "id": "512",
        "description": "Διαγνωστικό Πρωτόκολλο Οστεοπόρωσης",
        "parentId": "510",
        "reasons": [
            {
                "id": "714",
                "value": "Κατάγματα χαμηλής βίας.",
                "domain": "DP_OSTEOP_A00_49",
                "label": "Κατάγματα χαμηλής βίας."
            },
            {
                "id": "718",
                "value": "Πρωτοπαθής υπερπαραθυρεοειδισμός.",
                "domain": "DP_OSTEOP_A00_49",
                "label": "Πρωτοπαθής υπερπαραθυρεοειδισμός."
            },
            {
                "id": "716",
                "value": "Πρώιμη εμμηνόπαυση (κάτω των 45 ετών).",
                "domain": "DP_OSTEOP_A00_49",
                "label": "Πρώιμη εμμηνόπαυση (κάτω των 45 ετών)."
            },
            {
                "id": "719",
                "value": "Φαρμακευτική αγωγή σχετιζόμενη με απώλεια οστικής μάζας ή/και κίνδυνο κατάγματος (ενδεικτικά: στεροειδή, αναστολείς αρωματάσης).",
                "domain": "DP_OSTEOP_A00_49",
                "label": "Φαρμακευτική αγωγή σχετιζόμενη με απώλεια οστικής μάζας ή/και κίνδυνο κατάγματος (ενδεικτικά: στεροειδή, αναστολείς αρωματάσης)."
            },
            {
                "id": "717",
                "value": "Σύνδρομα δυσαπορρόφησης.",
                "domain": "DP_OSTEOP_A00_49",
                "label": "Σύνδρομα δυσαπορρόφησης."
            },
            {
                "id": "720",
                "value": "Άλλα παθολογικά νοσήματα σχετιζόμενα με απώλεια οστικής μάζας ή/και κίνδυνο κατάγματος (ενδεικτικά: ρευματοειδής αρθρίτιδα, σύνδρομο Cushing, σακχαρώδης διαβήτης, σοβαρή χρόνια αποφρακτική πνευμονοπάθεια, HIV/AIDS).",
                "domain": "DP_OSTEOP_A00_49",
                "label": "Άλλα παθολογικά νοσήματα σχετιζόμενα με απώλεια οστικής μάζας ή/και κίνδυνο κατάγματος (ενδεικτικά: ρευματοειδής αρθρίτιδα, σύνδρομο Cushing, σακχαρώδης διαβήτης, σοβαρή χρόνια αποφρακτική πνευμονοπάθεια, HIV/AIDS)."
            },
            {
                "id": "715",
                "value": "Υπογοναδισμός.",
                "domain": "DP_OSTEOP_A00_49",
                "label": "Υπογοναδισμός."
            }
        ]
    },
    {
        "id": "513",
        "description": "Διαγνωστικό Πρωτόκολλο Οστεοπόρωσης",
        "parentId": "510",
        "reasons": [
            {
                "id": "713",
                "value": "Άλλοι παράγοντες και νόσοι.",
                "domain": "DP_OSTEOP_A50_64",
                "label": "Άλλοι παράγοντες και νόσοι."
            },
            {
                "id": "711",
                "value": "Κατανάλωση οινοπνεύματος (πάνω από 25 γρ. ημερησίως).",
                "domain": "DP_OSTEOP_A50_64",
                "label": "Κατανάλωση οινοπνεύματος (πάνω από 25 γρ. ημερησίως)."
            },
            {
                "id": "708",
                "value": "Κάταγμα ισχίου γονέα.",
                "domain": "DP_OSTEOP_A50_64",
                "label": "Κάταγμα ισχίου γονέα."
            },
            {
                "id": "709",
                "value": "Σπονδυλικό κάταγμα ή/και οστεοπενική απεικόνιση οστών σε ακτινογραφίες.",
                "domain": "DP_OSTEOP_A50_64",
                "label": "Σπονδυλικό κάταγμα ή/και οστεοπενική απεικόνιση οστών σε ακτινογραφίες."
            },
            {
                "id": "710",
                "value": "Χαμηλό σωματικό βάρος (ΒMI κάτω από 20 kg/m2) ή/και απώλεια σωματικού βάρους πάνω από 10% από το βάρος του ασθενή στην ηλικία των 25 ετών.",
                "domain": "DP_OSTEOP_A50_64",
                "label": "Χαμηλό σωματικό βάρος (ΒMI κάτω από 20 kg/m2) ή/και απώλεια σωματικού βάρους πάνω από 10% από το βάρος του ασθενή στην ηλικία των 25 ετών."
            },
            {
                "id": "707",
                "value": "Κάταγμα χαμηλής βίας μετά την ηλικία των 40 ετών.",
                "domain": "DP_OSTEOP_A50_64",
                "label": "Κάταγμα χαμηλής βίας μετά την ηλικία των 40 ετών."
            },
            {
                "id": "712",
                "value": "Κάπνισμα.",
                "domain": "DP_OSTEOP_A50_64",
                "label": "Κάπνισμα."
            }
        ]
    },
    {
        "id": "514",
        "description": "Διαγνωστικό Πρωτόκολλο Οστεοπόρωσης",
        "parentId": "510",
        "reasons": [
            {
                "id": "721",
                "value": "Εκ του ιστορικού, της φυσικής εξέτασης και των αποτελεσμάτων του αρχικού εργαστηριακού ελέγχου κρίθηκε αναγκαία η διερεύνηση δευτεροπαθών αιτίων οστεοπόρωσης.",
                "domain": "DP_OSTEOP_C",
                "label": "Εκ του ιστορικού, της φυσικής εξέτασης και των αποτελεσμάτων του αρχικού εργαστηριακού ελέγχου κρίθηκε αναγκαία η διερεύνηση δευτεροπαθών αιτίων οστεοπόρωσης."
            }
        ]
    },
    {
        "id": "515",
        "description": "Διαγνωστικό Πρωτόκολλο Οστεοπόρωσης",
        "parentId": "510",
        reasons: [
            {
                "id": "721",
                "value": "Εκ του ιστορικού, της φυσικής εξέτασης και των αποτελεσμάτων του αρχικού εργαστηριακού ελέγχου κρίθηκε αναγκαία η διερεύνηση δευτεροπαθών αιτίων οστεοπόρωσης.",
                "domain": "DP_OSTEOP_C",
                "label": "Εκ του ιστορικού, της φυσικής εξέτασης και των αποτελεσμάτων του αρχικού εργαστηριακού ελέγχου κρίθηκε αναγκαία η διερεύνηση δευτεροπαθών αιτίων οστεοπόρωσης."
            }
        ]
    },
    {
        "id": "11",
        "description": "Έλεγχος παιδιάτρων",
        "parentId": "",
        "reasons": [
            {
                "id": "668",
                "value": "Aσθενής που η βιολογική του ωρίμανση αντιστοιχεί σε παιδική ηλικία ή ενήλικα με σπάνιο σύνδρομο που έχει ως συνέπεια δραματική καθυστέρηση σωματικής και πνευματικής ανάπτυξης ταυτόχρονα (ΦΕΚ 4698/τ Β’/19 10 2018)",
                "domain": "PED_OVERRIDE_REASON",
                "label": "Ασθενής που η βιολογική του ωρίμανση αντιστοιχεί σε παιδική ηλικία ή ενήλικα με σπάνιο σύνδρομο που έχει ως συνέπεια δραματική καθυστέρηση σωματικής και πνευματικής ανάπτυξης ταυτόχρονα (ΦΕΚ 4698/τ Β’/19 10 2018)"
            }
        ]
    },
    {
        "id": "9",
        "description": "Έλεγχος νοσηλείας ασθενή",
        "parentId": "",
        "reasons": [
            [
                {
                    "id": "507",
                    "value": "Εξερχόμενος ασθενής",
                    "domain": "OVERRIDE_REASON",
                    "label": "Εξερχόμενος ασθενής"
                },
                {
                    "id": "506",
                    "value": "Ημερήσια νοσηλεία",
                    "domain": "OVERRIDE_REASON",
                    "label": "Ημερήσια νοσηλεία"
                },
                {
                    "id": "508",
                    "value": "Δεν υπήρχε νοσηλεία",
                    "domain": "OVERRIDE_REASON",
                    "label": "Δεν υπήρχε νοσηλεία"
                },
                {
                    "id": "489",
                    "value": "Ο ασθενής έχει λάβει εξιτήριο",
                    "domain": "OVERRIDE_REASON",
                    "label": "Ο ασθενής έχει λάβει εξιτήριο"
                }
            ]
        ]
    },
    {
        "id": "12",
        "description": "Έλεγχος Προληπτικών Εξετάσεων",
        "parentId": "",
    }
]
